export default "__VITE_ASSET__CJiSpBVE__"